import classNames from '@/helpers/classNames';
import React from 'react';

type FormLabelProps = {
  label: string;
  required?: boolean;
  relative?: boolean;
  name: string;
};
export const FormLabel = ({ label, required = false, name, relative }: FormLabelProps) => {
  return (
    <label
      className={classNames('origin-left text-gray-500 duration-100', {
        'absolute top-3 z-10': relative !== true
      })}
      htmlFor={name}>
      {label}
      {required && <span>*</span>}
    </label>
  );
};
export default FormLabel;
